<template>
  <div>
    <NBar title="数据分析"/>
    <div class="top">
      <nut-scroller class="time-more">
        <div slot="list" @click="timeItemClick(index)"
             :style="{backgroundColor:timeSelect === item.label ? '#ffffff' : '#e9e9e9',
             border:timeSelect === item.label ? '1px solid #194fff' : '1px solid #e9e9e9',
             color:timeSelect === item.label ? '#194fff' : '#a1a5ab'}"
             class="time-item" v-for="(item ,index) in timeList" :key="index">{{ item.value }}
        </div>
      </nut-scroller>
    </div>
    <div class="card">
      <div style="margin: 0 10px;color: #9B9B9B; font-size: 16px;display:flex;">总收益概括<img @click="helpShow = true"
                                                                                          :src="require('../../../resource/img/device/svg/help.svg')"
                                                                                          style="width: 23px;height: 23px;margin-left: 15px;">
      </div>
      <nut-dialog title="数据说明" :visible="helpShow" ok-btn-txt="我知道了" @ok-btn-click="helpShow=false" no-cancel-btn
                  @close="helpShow=false">
        <div style="text-align: left;">
          <p>1. 每天更新暂时昨天经营数据</p>
          <p>2. 数据仅供经营状况参考</p>
        </div>
      </nut-dialog>
      <div style="margin-top: 5px;margin-left: 10px;">
        <nut-price :price="data.countMoney" style="zoom: 1.7;" :decimalDigits="2" :needSymbol="true" :thousands="true"/>
        <span v-if="data.moneyTrends === 0"
              style="color: #1afa29;margin-left: 20px;">较上周-{{ data.countMoneyPer || 0.00 }}%</span>
        <span v-if="data.moneyTrends === 1"
              style="color: #d81e06;margin-left: 20px;">较上周+{{ data.countMoneyPer || 0.00 }}%</span>
      </div>
    </div>
    <div class="card">
      <div
        style="margin-bottom:10px; width: 100%;display: flex;font-size: 14px;height: 30px;line-height: 30px;color: #9B9B9B;">
        <div style="width: 30%;"></div>
        <div style="width: 36%;">交易金额</div>
        <div style="width: 33%;">交易笔数</div>
      </div>
      <div style="height: 1px;background-color: #F5F6F8;width: 100%;"></div>
      <div style="width: 100%;display: flex;margin-top: 10px;"
           @click="$router.push(`/device/PayAnalysis?timeIndex=${timeSelect}`)">
        <div style="width: 30%;display: flex;align-items: center;margin-left: 10px;margin-right:-10px;">在线支付</div>
        <div style="width: 36%;display: flex;flex-direction: column;justify-content: center;">
          <nut-price :price="data.onlinePayMoney" :decimalDigits="2" :needSymbol="true" :thousands="true"
                     style="margin-bottom: 5px;"/>
          <span v-if="data.onlineMoneyTrends === 0"
                style="color: #1afa29;">-{{ data.onlinePayMoneyPer || 0.00 }}%</span>
          <span v-if="data.onlineMoneyTrends === 1"
                style="color: #d81e06;">+{{ data.onlinePayMoneyPer || 0.00 }}%</span>
        </div>
        <div style="width: 33%;display: flex;justify-content: space-between;align-items: center;">
          <div style="display: flex;flex-direction: column;justify-content: center;">
            <span style="font-size: 14px;font-weight: bold;margin-bottom: 5px;">{{ data.orderNum || 0 }}笔</span>
            <span v-if="data.orderNumTrends === 0"
                  style="color: #1afa29;">-{{ data.orderNumPer || 0 }}笔</span>
            <span v-if="data.orderNumTrends === 1"
                  style="color: #d81e06;">+{{ data.orderNumPer || 0 }}笔</span>
          </div>
          <img :src="require('../../../resource/img/device/arrow-right.png')" style="width: 25px;height: 25px;">
        </div>
      </div>
    </div>
    <nut-tabbar ref="tab" @tab-switch="tabSwitch" :tabbar-list="tabList" :bottom="true"/>
  </div>
</template>

<script>
/**
 * 数据分析
 */
export default {
  name: 'DataAnalysis',
  data () {
    return {
      //当前选择时间索引
      timeSelect: 0,
      timeList: [],
      tabList: [
        {
          'tabTitle': '场地收益',
          'curr': false,
          'icon': require('../../../resource/img/device/svg/site_icon.svg'),
          'activeIcon': require('../../../resource/img/device/svg/site_icon_active.svg')
        },
        {
          'tabTitle': '收益趋势',
          'curr': false,
          'icon': require('../../../resource/img/device/svg/trends.svg'),
          'activeIcon': require('../../../resource/img/device/svg/trends_active.svg')
        },
        {
          'tabTitle': '数据分析',
          'curr': true,
          'icon': require('../../../resource/img/device/svg/data_analysis.svg'),
          'activeIcon': require('../../../resource/img/device/svg/data_analysis_active.svg')
        }
      ],
      //说明弹窗
      helpShow: false,
      data: {}
    }
  },
  created () {
    let date = new Date()
    for (let i = 0; i < 7; i++) {
      let day = date.getDate()
      date.setDate(day - i)
      let dateStr1 = this.$util.formatDate.format(date, 'MM/dd')
      dateStr1 = dateStr1.replace(/-/g, '/')
      let dateStr2 = this.$util.formatDate.format(date, 'yyyy/MM/dd')
      dateStr2 = dateStr2.replace(/-/g, '/')
      let items = {
        label: i,
        value: dateStr1,
        date: dateStr2
      }
      if (i === 0) {
        items.value = '昨天'
      }
      this.timeList.push(items)
    }
  },
  activated () {
    this.$refs.tab.currIndex = 2
    this.getData()
  },
  methods: {
    getData () {
      let date = this.timeList[this.timeSelect].date
      date = date.replace(/-/g, '/')
      let startTime = new Date(date + ' 00:00:00')
      let endTime = new Date(date + ' 23:59:59')
      let data = {
        startTime: startTime.getTime() / 1000,
        endTime: endTime.getTime() / 1000
      }
      if (!this.$util.isArrOrNull(this.$api.merId)) {
        data.merId = this.$api.merId
      }
      if (!this.$util.isArrOrNull (this.$api.user.merIds)) {
        data.merIds = this.$api.user.merIds
      }
      this.$api.post({
        url: '/device/api/device/order/data-analysis',
        data: data,
        loading: false
      }).then(res => {
        this.data = res.data
      })
    },
    //日期快捷选择
    timeItemClick (index) {
      this.timeSelect = index
      this.getData()
    },
    tabSwitch: function (item, index) {
      switch (index) {
        case 0:
          this.$router.replace('/device/SiteEarnings')
          break
        case 1:
          this.$router.replace('/device/SiteEarningsTrend')
          break
        case 2:
          this.getData()
          break
      }
    }
  }
}
</script>

<style scoped>
>>> .curr {
  color: #1a87ff;
}

>>> .nut-dialog-btn:only-child {
  color: #1a87ff;
}

>>> .nut-dialog-ok:active {
  background: #1a87ff;
  color: white;
}

.top {
  display: flex;
  flex-direction: column;
  background-color: white;
}

.top .time-more {
  margin: 10px 0;
}

.top .time-more .time-item {
  font-size: 14px;
  background-color: #e9e9e9;
  border: 1px solid #e9e9e9;
  color: #a1a5ab;
  border-radius: 5px;
  width: 50px;
  text-align: center;
  padding: 4px 3px;
  margin-left: 10px;
}

.card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: white;
  border-radius: 7px;
  padding: 20px 0;
  margin: 15px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/device/home/DataAnalysis.vue